module.exports = __webpack_public_path__ + "img/25_1.6763fce4.png";